import gql from "graphql-tag";

export const GET_MOBILIZATIONS_LAST_SCAN = gql`
  query ($affiliate: String) {
    getMobilizationScanInfo(affiliate: $affiliate) {
      lastScanDate
    }
  }
`;
